<template>
    <div>
        <div class="sm:hidden">
            <label for="tabs" class="sr-only">Select a tab</label>
            <BlogMobileDropdown
                :current-category="currentCategory"
                :categories="categories"
            />
        </div>
        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex" aria-label="Tabs">
                    <NuxtLink
                        v-for="category in categories"
                        :key="'category-menu-' + category"
                        class="font-medium w-1/4 border-b-2 px-1 py-4 text-center text-lg hover:cursor-pointer"
                        :class="[
                            category.id === currentCategory
                                ? 'border-grind font-bold text-grind'
                                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                        ]"
                        :to="
                            normalizeUrl(category.slug + '#blog-category-menu')
                        "
                    >
                        {{ capitalizeWords(category.label) }}
                    </NuxtLink>
                </nav>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ArticleCategoryType } from '#shared/types/ArticleCategoryType';
import BlogMobileDropdown from '~/components/page-building/blog/BlogMobileDropdown.vue';
import normalizeUrl from '~/utils/normalizeUrl';

defineProps<{
    categories: ArticleCategoryType[];
    currentCategory: string;
}>();
</script>
